<template>
	<DjBox class="pt-5 md:pt-8 px-5 md:px-10 pb-5 md:pb-10">
		<h3 class="text-lg md:text-xl font-medium mb-8">{{ title }}</h3>
		<dl>
			<dt
				class="relative pl-8 mt-5 mb-2 font-medium before:content-[''] before:absolute before:-left-0 before:top-1 before:w-3 before:h-3 before:rounded-full before:bg-dj-blue"
			>
				{{ sizeTitle }}
			</dt>
			<dd class="pl-8">{{ sizeText }}</dd>
			<dt
				class="relative pl-8 mt-5 mb-2 font-medium before:content-[''] before:absolute before:-left-0 before:top-1 before:w-3 before:h-3 before:rounded-full before:bg-dj-blue"
			>
				{{ ageTitle }}
			</dt>
			<dd class="pl-8">{{ ageText }}</dd>
		</dl>
	</DjBox>
</template>

<script lang="ts">
import DjBox from "./DjBox.vue";

import { defineComponent, PropType } from "vue";

export default defineComponent({
	name: "DjBoxJobTeamInfo",
	components: {
		DjBox,
	},
	props: {
		title: {
			type: String,
			default: "",
			required: true,
		},
		ageTitle: {
			type: String,
			default: "",
			required: false,
		},
		ageText: {
			type: String,
			default: "",
			required: false,
		},
		sizeTitle: {
			type: String,
			default: "",
			required: false,
		},
		sizeText: {
			type: String,
			default: "",
			required: false,
		},
	},
});
</script>
